"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var typeChecks_1 = require("../../utils/typeChecks");

var AliasTransform =
/** @class */
function (_super) {
  __extends(AliasTransform, _super);

  function AliasTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AliasTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var response = queryResponse;
    var aliases = this.options.aliases;

    if (queryResponse) {
      for (var _i = 0, aliases_1 = aliases; _i < aliases_1.length; _i++) {
        var alias = aliases_1[_i];
        var source = alias.source,
            replacement = alias.replacement,
            fullMatchOnly = alias.fullMatchOnly;
        var replacementString = typeChecks_1.isNullOrUndefined(replacement) ? '' : replacement;
        var responseString = typeChecks_1.isNullOrUndefined(response) ? '' : response.toString();

        if (fullMatchOnly) {
          if (responseString === source) {
            response = replacement;
            break;
          }
        } else {
          response = responseString.split(source).join(replacementString);
        }
      }
    }

    return response;
  };

  return AliasTransform;
}(BaseTransform_1.BaseTransform);

exports.AliasTransform = AliasTransform;